import { StepGroups } from '../../lib/constants/steps';
import { getStepsByGroup } from '../../lib/utils/stepCalculator/stepUtils';

/**
 * Checks if the given stepSlug is the last in its visualized step group.
 * @param StepGroups - The current visualized step (e.g., 'personalize')
 * @param stepSlug - The route param/step slug to check (e.g., 'choose-banners')
 * @returns true if stepSlug is the last in the group, false otherwise
 */
export function isLastStepInStepGroups(StepGroups: StepGroups, stepSlug: string): boolean {
    const steps = getStepsByGroup(StepGroups);
    return steps[steps.length - 1] === stepSlug;
}
